import React, { useState, useEffect } from "react";
import "./VendorDetail.scss";
import {
  AssessmentButton,
  CheckboxRadio,
  SearchTypeSelect,
  TemplateSearch,
  Pagination,
  SkeletonList,
  showToast,
} from "ui-components";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  invitePartnerToJob,
  getAcceptedPartnersWithSkillMatch,
  getPartnerLocationList,
} from "../../../../../../service/StaffAugumentation/StaffAugumentationApis";
import Loader from "../../../../../../components/Loader/Loader";
import CircleCrossIcon from "../../../../../../utils/Images/CircleCrossIcon";
import ComingSoon from "../../../../Common/ComingSoon/ComingSoon";
import useDebounce from "../../../../../../utils/Hooks/useDebounce";
import { copyText } from "../../../../../../utils/Common/Constant";

interface VendorDetailsProps {
  goBack: () => void;
  fetchVendors: any;
  refreshSidebarVendors: any;
}

export default function VendorsDetails({
  // goBack,
  fetchVendors,
  refreshSidebarVendors,
}: VendorDetailsProps) {
  const { jobId } = useParams();
  const { t } = useTranslation();
  const [vendorsData, setVendorsData] = useState<any[]>([]);
  const [partnerCompanyDetails, setPartnerCompanyDetails] = useState<any[]>([]);
  const [inviteBtnLoading, setInviteBtnLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const searchTermDebounced = useDebounce(searchTerm, 500);
  const [locationFilter, setLocationFilter] = useState<any>([]);
  const [vendorListLoader, setVendorListLoader] = useState(false);
  const [checkTerms, setCheckTerms] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [locationOptions, setLocationOptions] = useState<any>([]);
  const toggleSelect = (vendor: any) => {
    setPartnerCompanyDetails((prev) => {
      const exists = prev.find((v) => v.companyUserId === vendor.companyUserId);
      if (exists) {
        return prev.filter((v) => v.companyUserId !== vendor.companyUserId);
      } else {
        return [
          ...prev,
          {
            partnerCompanyId: vendor.partnerCompanyId,
            companyUserId: vendor.companyUserId,
          },
        ];
      }
    });
  };
  const invitePartnerToJobApi = async () => {
    setInviteBtnLoading(true);
    const modifiedData = partnerCompanyDetails?.map(
      ({ companyUserId, ...rest }) => ({
        ...rest,
        partnerUserId: companyUserId,
      }),
    );

    const data = {
      jobId,
      partnerCompanyDetails: modifiedData,
    };

    const result = await invitePartnerToJob(data);
    if (result?.status === 200) {
      fetchVendors();
      getAcceptedPartner();
      refreshSidebarVendors();
      showToast(t("VENDOR.INVITED_SUCCESSFULLY"), "success");
      setPartnerCompanyDetails([]);
    }
    setInviteBtnLoading(false);
  };
  const getAcceptedPartner = async () => {
    setVendorListLoader(true);

    // Extract stateId and city arrays from locationFilter
    const stateIds = locationFilter.map((location: any) => location.stateId);
    const cities = locationFilter.map((location: any) => location.city);
    const response = await getAcceptedPartnersWithSkillMatch(
      jobId,
      checkTerms,
      searchTerm,
      currentPage,
      pageSize,
      cities ?? [],
      stateIds ?? [],
    );
    if (response?.status == 200) {
      setTotalCount(response?.data?.totalCount);
      setVendorsData(response?.data?.data);
      setVendorListLoader(false);
    } else {
      setVendorListLoader(false);
    }
  };
  useEffect(() => {
    getPartnerLocations();
  }, []);
  // get accepted partners
  useEffect(() => {
    getAcceptedPartner();
  }, [
    jobId,
    pageSize,
    currentPage,
    checkTerms,
    searchTermDebounced,
    locationFilter,
  ]);

  const selectAll = () => {
    if (partnerCompanyDetails.length === vendorsData.length) {
      setPartnerCompanyDetails([]);
    } else {
      setPartnerCompanyDetails(
        vendorsData.map((v: any) => ({
          partnerCompanyId: v.partnerCompanyId,
          companyUserId: v.companyUserId,
        })),
      );
    }
  };
  const getPartnerLocations = async () => {
    const res = await getPartnerLocationList();
    if (res?.status === 200) {
      const uniqueLocations = new Map();
      const options = res?.data?.reduce((acc: any[], item: any) => {
        const locationKey = `${item.city}-${item.stateName}-${item.countryName}`;
        if (!uniqueLocations.has(locationKey)) {
          uniqueLocations.set(locationKey, true);
          acc.push({
            label: `${item.city} , ${item.stateName} , ${item.countryName}`,
            value: item.companyId,
            stateId: item.stateId,
            city: item?.city,
          });
        }
        return acc;
      }, []);
      setLocationOptions(options);
    }
  };
  // delete
  const handleDeleteFilterLocation = (ind: number) => {
    setLocationFilter((prevData: any) => {
      const newData = prevData.filter((_: any, index: number) => index !== ind);
      return newData;
    });
  };
  return (
    <div className="vendorWrapper">
      <div className="inviteToJobBtn">
        {inviteBtnLoading ? (
          <AssessmentButton disabled className={"loadingBtn"}>
            {t("GENERAL.PLEASE_WAIT")}
            <Loader />
          </AssessmentButton>
        ) : (
          <AssessmentButton
            onClick={invitePartnerToJobApi}
            disabled={partnerCompanyDetails.length === 0}
            size="lg"
            variant="primary"
          >
            {t("GENERAL.INVITE_TO_JOB")}
          </AssessmentButton>
        )}
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="vendorSearchSection">
            <div className="vendorSearch">
              <TemplateSearch
                value={searchTerm}
                placeholder={t("GENERAL.SEARCH_EVENT")}
                onChange={(value: string) => {
                  setSearchTerm(value);
                  setCurrentPage(1);
                }}
                iconName="searchList"
              />
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="vendorFilterSec">
            <div className="locationSec">
              <div className="locationDropdownSec">
                <SearchTypeSelect
                  options={locationOptions}
                  value={locationFilter}
                  placeholder={t("GENERAL.SELECT_LOCATION")}
                  onChange={(value: any) => {
                    setLocationFilter((prev: any) => {
                      const exists = prev.some(
                        (item: any) => item.value === value.value,
                      );
                      if (!exists) {
                        return [...prev, value];
                      }
                      return prev;
                    });
                  }}
                />
              </div>
              {locationFilter?.length ? (
                <div className="d-flex  gap-1 align-items-center mt-3 addedSkill">
                  {locationFilter
                    // ?.filter((item: any) => item.skillName && item)
                    ?.map((item: any, index: any) => {
                      return (
                        <div key={index} className="word">
                          <span>{item?.label}</span>
                          <div
                            onClick={() => handleDeleteFilterLocation(index)}
                            className="deleteKeyword"
                          >
                            <CircleCrossIcon
                              color="var(--primary-white)"
                              width="16px"
                              height="16px"
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="selectAllSection">
              <div className="availabelCheck">
                <CheckboxRadio
                  checked={checkTerms}
                  onChange={() => setCheckTerms(!checkTerms)}
                  type={"checkbox"}
                  label={t("VENDOR.AVAILABLE_RESOURCES")}
                />
              </div>
              <div className="availabelCheck">
                <CheckboxRadio
                  checked={
                    vendorsData?.length > 0 &&
                    partnerCompanyDetails?.length === vendorsData?.length
                  }
                  onChange={selectAll}
                  type={"checkbox"}
                  label={t("RESUME.ASSESSMENT_SELECT_ALL")}
                />
              </div>
            </div>
          </div>
          {totalCount ? (
            <div className="scannedUnscannedCvs">
              <span>
                {t("VENDOR.TOTAL_VENDOR")} : {totalCount}
              </span>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="minHeight60">
        {vendorListLoader ? (
          <>
            {Array.from({ length: 3 }).map((_, index) => (
              <SkeletonList
                key={`skeleton-${index}`}
                numberOfTitles={1}
                numberofTextLines={2}
                titleSize={15}
                textSize={10}
                thumbnailHeight={120}
                thumbnailWidth={120}
                itemsGap={10}
              />
            ))}
          </>
        ) : vendorsData?.length === 0 ? (
          <ComingSoon text={t("VENDOR_NO_VENDOR_AVAILABLE")} />
        ) : (
          vendorsData?.map((vendor) => {
            const isSelected = partnerCompanyDetails.some(
              (v) => v.companyUserId === vendor.companyUserId,
            );

            return (
              <div className="container " key={vendor.companyUserId}>
                <div
                  className={`vendoreProfileSec ${
                    isSelected ? "checkedBrClr" : "unCheckedBrClr"
                  }`}
                  onClick={() => {
                    toggleSelect(vendor);
                  }}
                >
                  <div className="row vendorProfileRow">
                    <div className="col-sm-12 col-xl-2">
                      <div className="vendorProfile">
                        <span>
                          <img src={vendor?.logo} alt="" />
                        </span>
                      </div>
                    </div>
                    <div className="col-md-10 col-xl-9">
                      <div className="vendorsDetails row">
                        <div className="col-md-6 col-xl-4">
                          <div className="vendorSubDetails">
                            <div>
                              <h2>
                                {vendor?.firstName || vendor?.lastName ? (
                                  <>
                                    {vendor?.firstName ? (
                                      <span>{vendor?.firstName}</span>
                                    ) : (
                                      ""
                                    )}
                                    &nbsp;
                                    {vendor?.lastName ? (
                                      <span>{vendor?.lastName}</span>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ) : (
                                  "-"
                                )}
                              </h2>
                              <h6 onClick={() => copyText(vendor?.email)}>
                                {vendor?.email}
                              </h6>
                              <h6>{vendor?.mobile ? vendor?.mobile : "-"}</h6>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xl-3">
                          <div className="vendorSubDetails">
                            <span>{t("CONTRACT.VENDOR")}</span>
                            <h3>{vendor?.companyName}</h3>
                          </div>
                        </div>

                        <div className="col-md-6 col-xl-3">
                          <div className="vendorSubDetails">
                            <span>{t("GENERAL.COMPANY_LOCATION")}</span>
                            <h3>{vendor?.city}</h3>
                          </div>
                        </div>
                        <div className="col-md-6 col-xl-2">
                          <div className="vendorSubDetails">
                            <span>{t("GENERAL.BENCH")}</span>
                            <h3>{vendor?.resources}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2 col-lg-1 col-xl-1 vendorCheckCol ">
                      <div className="vendorsCheck">
                        <div onClick={(e) => e.stopPropagation()}>
                          <CheckboxRadio
                            checked={isSelected}
                            onChange={() => toggleSelect(vendor)}
                            type="checkbox"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
      <div className="container row p-2">
        <div className="col-md-12">
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={totalCount > pageSize ? totalCount : 0}
            pageSize={pageSize}
            onPageChange={(page: number) => setCurrentPage(page)}
            ofLabel={t("GENERAL.OF")}
            resultLabel={t("GENERAL.RESULTS")}
            setPageSize={setPageSize}
          />
        </div>
      </div>
    </div>
  );
}
